import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";

const defaultState = { isActive: true, isReachable: true };

const CollapsibleGroupContext = createContext({
  register: () => {},
  reportValue: () => {},
  getState: () => defaultState,
});

export function CollapsibleGroupProvider({ children }) {
  const questionsRef = useRef(new Map());
  const [, forceUpdate] = useState(0);

  const register = useCallback((key, order) => {
    const map = questionsRef.current;
    if (!map.has(key)) {
      map.set(key, { order, hasValue: false });
      forceUpdate((n) => n + 1);
    }
  }, []);

  const reportValue = useCallback((key, hasValue) => {
    const map = questionsRef.current;
    const entry = map.get(key);
    if (entry && entry.hasValue !== hasValue) {
      entry.hasValue = hasValue;
      forceUpdate((n) => n + 1);
    }
  }, []);

  const getState = useCallback((key) => {
    const map = questionsRef.current;
    const sorted = [...map.entries()].sort((a, b) => a[1].order - b[1].order);
    const firstUnanswered = sorted.find(([, q]) => !q.hasValue);

    const isActive = firstUnanswered?.[0] === key;
    const entry = map.get(key);
    const isReachable = entry?.hasValue || isActive;

    return { isActive, isReachable };
  }, []);

  return (
    <CollapsibleGroupContext.Provider
      value={{ register, reportValue, getState }}
    >
      {children}
    </CollapsibleGroupContext.Provider>
  );
}

export function useCollapsibleGroup() {
  return useContext(CollapsibleGroupContext);
}
